import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  TixBuyerProductFragmentFragment,
  TixGetItemsAmountsSoldGQL
} from '@tix/data-access';
import { BuyerProductService } from '@tix/event-buyer/components';
import {
  OrderStateManagerService,
  PortalCheckoutService
} from '@tix/event-buyer/services';
import { fadeInUp400ms } from '@tix/ui-common';
import { OrderSelectBaseComponent } from 'libs/event-buyer/components/src/lib/order-select-base/order-select-base.component';
import { Subject, interval } from 'rxjs';
import { map, switchMap, take, takeUntil } from 'rxjs/operators';

/**
 * Algorithm (summary page): hold product
 *
 * . Query event products
 * . Patch quantities for the current session from Redis(hold) not local storage.
 * . Get hold from others.
 * . Check if current session already increased any addon quantity.
 * . `Quantity remaining` = eventProduct.quantityRemaining - (hold by other sessions + hold by current session).
 * . Hold new values if quantities updated.
 * . Purshase: delete current session from hold.
 */
@Component({
  selector: 'tix-products-summary',
  templateUrl: './products-summary.component.html',
  animations: [fadeInUp400ms]
  // dont OnPush this component
})
export class ProductsSummaryComponent
  extends OrderSelectBaseComponent
  implements OnInit, OnDestroy
{
  //
  @Output()
  increaseProduct = new EventEmitter();
  @Output()
  decreaseProduct = new EventEmitter();

  @Output()
  selectionChanged = new EventEmitter<
    (TixBuyerProductFragmentFragment & { selected: number })[]
  >();

  // start addons variable
  products: TixBuyerProductFragmentFragment[] = [];
  //

  constructor(
    private _buyerProductService: BuyerProductService,
    private portalCheckoutService: PortalCheckoutService,
    orderStateManager: OrderStateManagerService,
    getAmountsSoldQuery: TixGetItemsAmountsSoldGQL,
    cd: ChangeDetectorRef
  ) {
    super(orderStateManager, getAmountsSoldQuery, cd);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.init();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  trackByFn(idx: number, product: any) {
    return product.quantityRemaining || product.sold;
  }

  override async onOrderChanged(): Promise<void> {
    await super.onOrderChanged();

    this.emitProductsChange();
  }

  emitProductsChange() {
    this.selectionChanged.emit(
      this.products.map(p => ({
        ...p,
        selected: this.orderStateManager.getQuantitySelectedForItem(
          p.eventProductId
        )
      }))
    );
  }

  async init() {
    this.orderStateManager.loadPersistedOrder();
    this.products = await this._buyerProductService.getAddonsForEvent(
      this.#getEventId()
    );

    this.orderStateManager.addOrderItems(
      this.products.map(p => {
        return {
          id: p.eventProductId,
          isPoolParent: true,
          quantitySold: p.quantitySold ?? 0,
          totalQuantity: p.quantity ?? 0,
          type: 'product'
        };
      })
    );
    await this.orderStateManager.loadOrderFromHold();
    console.log(this.orderStateManager.getOrderItems());
    this.orderSelectionInitialized = true;
    this.emitProductsChange();
  }

  #getEventId() {
    const order = this.portalCheckoutService.getPersistedOrderInfo();
    return order?.eventInstanceId as string;
  }
}
